module.exports = __webpack_public_path__ + "36019a1830a7b450699443b72969ccbf.png";